<template>
  <form ref="form" :action="action" @submit.prevent="submit" method="POST">
    <input ref="csrf" :value="csrfToken" type="hidden" name="authenticity_token" />
    <div class="mb-4">
      <h1>{{ translations.heading }}</h1>
      <FormInput
        :label="translations.form.company_name.label"
        :placeholder="translations.form.company_name.placeholder"
        :value="params.company_name"
        required
        name="company_name"
        type="text"
      />
      <FormInput
        :label="translations.form.company_legal_name.label"
        :placeholder="translations.form.company_legal_name.placeholder"
        :value="params.company_legal_name"
        required
        name="company_legal_name"
        type="text"
      />
      <div class="form-row">
        <div class="col-sm-16">
          <FormInput
            :label="translations.form.street.label"
            :placeholder="translations.form.street.placeholder"
            :value="params.street"
            required
            name="street"
            type="text"
          />
        </div>
        <div class="col-sm-8">
          <FormInput
            :label="translations.form.street_number.label"
            :placeholder="translations.form.street_number.placeholder"
            :value="params.street_number"
            required
            name="street_number"
            type="text"
          />
        </div>
      </div>
      <FormInput
        :label="translations.form.postal_code.label"
        :placeholder="translations.form.postal_code.placeholder"
        :value="params.postal_code"
        required
        name="postal_code"
        type="text"
      />
      <FormInput
        :label="translations.form.city.label"
        :placeholder="translations.form.city.placeholder"
        :value="params.city"
        required
        name="city"
        type="text"
      />
      <label>{{ translations.form.country.label }}</label>
      <select :label="translations.form.country.label" required name="country" class="form-control">
        <option
          v-for="country in countries"
          :key="country.iso"
          :value="country.iso"
          :selected="country.iso === params.country"
        >
          {{ country.label }}
        </option>
      </select>
    </div>
    <div class="mb-4">
      <p class="h4 mb-1">{{ translations.form.marketplace.label }}</p>
      <select required name="city_zone_id" class="form-control">
        <option
          v-for="city_zone in city_zones"
          :key="city_zone.label"
          :value="city_zone.id"
          :selected="city_zone.id === params.city_zone_id"
        >
          {{ city_zone.label }}
        </option>
      </select>
    </div>
    <div class="mb-3">
      <p class="h4">{{ translations.form.further_data }}</p>
      <FormInput
        :label="translations.form.first_name.label"
        :placeholder="translations.form.first_name.placeholder"
        :value="params.name"
        required
        name="name"
        type="text"
      />
      <FormInput
        :label="translations.form.surname.label"
        :placeholder="translations.form.surname.placeholder"
        :value="params.surname"
        required
        name="surname"
        type="text"
      />
      <FormInput
        :label="translations.form.phone.label"
        :placeholder="translations.form.phone.placeholder"
        :value="params.phone"
        required
        name="phone"
        type="tel"
      />
      <FormInput
        v-if="operatorLetzshop"
        :label="translations.form.iban.label"
        :placeholder="translations.form.iban.placeholder"
        :value="params.external_account_iban"
        required
        name="external_account_iban"
        type="text"
      />
      <FormInput
        v-if="operatorLetzshop"
        :label="translations.form.bic.label"
        :placeholder="translations.form.bic.placeholder"
        :value="params.external_account_bic"
        required
        name="external_account_bic"
        type="text"
      />
      <FormInput
        v-if="operatorLetzshop"
        :label="translations.form.homepage.label"
        :placeholder="translations.form.homepage.placeholder"
        :value="params.homepage"
        name="homepage"
        type="url"
      />
    </div>
    <div class="mb-3">
      <slot></slot>
    </div>

    <input :value="params.interest" type="hidden" name="interest" />
    <button type="submit" class="btn btn-primary btn-lg btn-block">
      {{ translations.form.submit }}
    </button>
  </form>
</template>

<script>
import FormInput from "./FormInput";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "OnboardingSignupForm",
  components: {
    FormInput,
  },
  props: {
    action: {
      type: String,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
    city_zones: {
      type: Array,
      required: true,
    },
    operatorBrand: {
      type: String,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { operatorLetzshop: this.operatorBrand == "Letzshop" };
  },
  computed: {
    ...mapGetters({
      csrfToken: "getCsrfToken",
    }),
  },
  created() {
    this.setErrors(this.errors);
  },
  methods: {
    ...mapActions({
      fetchCsrfToken: "fetchCsrfToken",
      setLoadingOverlayVisibility: "onboarding/setLoadingOverlayVisibility",
      setErrors: "validations/setErrors",
    }),
    async submit() {
      let { form } = this.$refs;
      if (form.checkValidity()) {
        await this.fetchCsrfToken();
        this.$nextTick(function() {
          form.submit();
        });
        this.setLoadingOverlayVisibility(true);
      } else {
        form.reportValidity();
      }
    },
  },
};
</script>
